/* Demo stub — brak połączenia z API */
import { createNamedStub, createServiceStub } from "../demo/stubHelpers";
import {
  getMockCompleteNotificationsPage,
  getMockNotificationsPage,
  getMockSeenNotificationsPage,
} from "../demo/mockNotifications";

const notificationsServices = {
  ...createServiceStub(),
  getAllNotifications: async (pageInfo: any) => getMockNotificationsPage(pageInfo),
  getNotificationsIsComplete: async (pageInfo: any) =>
    getMockCompleteNotificationsPage(pageInfo),
  getNotificationsIsSee: async (pageInfo: any) => getMockSeenNotificationsPage(pageInfo),
  seeNotification: createNamedStub({}),
  remove: createNamedStub({}),
  trainerPassNotificationReminder: async (..._args: any[]) => ({ Success: true }),
};

export default notificationsServices;
